<script>

export default {
    name: 'InputCustomRadio',

    emits: ['filter-updated'],

    props: {
        checkedValue : {
            type: String,
            default: null
        },
        desc : {
            type: String,
            default: null,
        },
        filter : {
            type: String,
            required: true
        },
        icon : {
            type: String,
        },
        iconType : {
            type: String,
        },
        label : {
            type: String,
        },
        quantity : {
            type: Number,
        },
        value : {
            type: String,
        },
    },

    data: function () {
        return {
            vModel: null,
        };
    },

    created() {
        if(this.isChecked()) {
            this.triggerEmit();
        }
    },


    watch: {
        checked(newValue) {
            if (newValue === false) {
                this.vModel = null;
            }
        }
    },

    computed: {
        setLabelClass() {
          return this.isChecked() ? 'input-radio-icon--active selected' : '';
        },

        disabled() {
            // return (this.quantity === 0 && this.checkedValue );
            return false;
        },

        iconTypeClass() {
            return this.iconType.length ? `input-radio-icon--${this.iconType}` : ''
        }
    },

    methods: {
        isChecked() {
            // check if value is equal checkedValue
            // or if unselected
            return this.checkedValue === this.value || !this.checkedValue && this.value === 'all';
        },

        valueChanged(newValue) {
            this.vModel = newValue;
            this.triggerEmit();
        },

        triggerEmit() {
            // console.log('triggerEmit ?');
            if (this.vModel) {
                const filterValue = this.vModel === 'all' ? null : this.vModel;
                // console.log('😎 triggerEmit: '+this.filter+' => '+filterValue);
                this.$emit("filter-updated", this.filter, filterValue, "===");
            }
        },
    },
}
</script>

<template>
    <label @click="valueChanged(value)"
           tabindex="0"
           class="input-radio-icon"
           :class="[setLabelClass, iconTypeClass]"
           :for="value">
        <input
               type="radio"
               :checked="isChecked()"
               v-model="vModel"
               :value="value"
               :id="value"
               :name="value"
               :disabled="disabled" />
        <span v-if="icon" v-html="icon"></span>
        <span class="input-radio-icon__desc">{{desc}} ({{quantity}})</span>
    </label>
</template>
